import { createContext } from "react"

export const AllContextData = createContext();